import React from "react";
import Button from "../../../components/ui/Button";
import Icon from "../../../components/AppIcon";
import Image from "../../../components/AppImage";

const UserTable = ({ users, metaUsers, onEdit, onDelete, onPageChange }) => {
  if (!metaUsers) return null;

  const {
    current_page,
    last_page,
    from,
    to,
    total,
    prev_page_url,
    next_page_url,
  } = metaUsers;

  const pages = Array.from({ length: last_page }, (_, i) => i + 1);

  const getStatusColor = (status) =>
    status === "Active" ? "text-success" : "text-text-secondary";

  const getStatusDot = (status) =>
    status === "Active" ? "bg-success" : "bg-text-secondary";
console.log(users)
  return (
    <div className="bg-card rounded-xl border border-border overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full min-w-[800px] text-center">
          <thead className="bg-muted border-b">
            <tr>
              <th className="px-6 py-4">المستخدمون</th>
              <th className="px-6 py-4">رقم الهاتف</th>
              <th className="px-6 py-4">تاريخ الميلاد</th>
              <th className="px-6 py-4">الصلاحية</th>
              <th className="px-6 py-4">الحالة</th>
              <th className="px-6 py-4">الأحداث</th>
            </tr>
          </thead>

          <tbody className="divide-y">
            {users?.map((user) => (
              <tr
                key={user.id}
                className="hover:bg-muted/40 transition-smooth"
              >
                {/* User */}
                <td className="px-6 py-4">
                  <div className="flex items-center justify-center gap-3">
                    <Image
                      src={user.avatar}
                      alt={user.name}
                      className="w-10 h-10 rounded-full"
                    />
                    <span className="font-medium">{user.name}</span>
                  </div>
                </td>

                {/* Phone */}
                <td className="px-6 py-4 text-text-secondary">
                  {user.phone_number}
                </td>

                {/* Birthday */}
                <td className="px-6 py-4 text-text-secondary">
                  {user.birthday}
                </td>

                {/* Role */}
                <td className="px-6 py-4">
                  <span className="inline-flex px-3 py-1 rounded-full text-sm bg-primary/10 text-primary">
                    {user.role}
                  </span>
                </td>

                {/* Status */}
                <td className="px-6 py-4">
                  <div className="flex items-center justify-center gap-2">
                    <span
                      className={`w-2 h-2 rounded-full ${getStatusDot(
                        user.status,
                      )}`}
                    />
                    <span
                      className={`text-sm font-medium ${getStatusColor(
                        user.status,
                      )}`}
                    >
                      {user.status=="Active"?"نشط":"غير نشط"}
                    </span>
                  </div>
                </td>

                {/* Actions */}
                <td className="px-6 py-4">
                  <div className="flex items-center justify-center gap-2">
                    <button
                      onClick={() => onEdit(user.id)}
                      className="p-2 rounded-lg hover:bg-primary/10 text-primary transition"
                    >
                      <Icon name="Edit2" size={16} />
                    </button>
                    <button
                      onClick={() => onDelete(user)}
                      className="p-2 rounded-lg hover:bg-error/10 text-error transition"
                    >
                      <Icon name="Trash2" size={16} />
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      <div className="flex flex-col sm:flex-row justify-between items-center p-4 bg-muted/30 gap-3">
        <span className="text-sm text-text-secondary">
          {from}-{to} من {total}
        </span>

        <div className="flex gap-1 flex-wrap">
          <Button
            size="sm"
            variant="outline"
            disabled={!prev_page_url}
            onClick={() => onPageChange(current_page - 1)}
          >
            السابق
          </Button>

          {pages.map((page) => (
            <Button
              key={page}
              size="sm"
              variant={page === current_page ? "default" : "outline"}
              onClick={() => onPageChange(page)}
            >
              {page}
            </Button>
          ))}

          <Button
            size="sm"
            variant="outline"
            disabled={!next_page_url}
            onClick={() => onPageChange(current_page + 1)}
          >
            التالي
          </Button>
        </div>
      </div>
    </div>
  );
};

export default UserTable;
